import { render, staticRenderFns } from "./simple-pagination.vue?vue&type=template&id=3d8b30b3&"
import script from "./simple-pagination.vue?vue&type=script&lang=js&"
export * from "./simple-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports